import { createSelector } from '@reduxjs/toolkit';
import { selectMortgageMonthlyPaymentTo } from 'shared/selectors/jsonQuery';

export const selectMortgageMonthlyPaymentFilter = createSelector([selectMortgageMonthlyPaymentTo], value => ({
  value,
}));
